import { FC, PropsWithChildren, ReactNode, useCallback, useEffect, useState } from "react"
import { Form, Button, Table } from 'antd'
import styles from './style.module.less'

type PropType = FC<PropsWithChildren<{
  searchForm?: ReactNode
  columns: any[]
  rowKey: any
  load: (values) => Promise<{status?: boolean, data: any[], success?: boolean, total: number}>
}>>

const QueryForm: PropType = ({columns, rowKey, children, searchForm, load}) => {
  const [form] = Form.useForm()
  const [data, setData] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)

  const loadCore = useCallback(async () => {
    setLoading(true)
    const res = await load(form.getFieldsValue()).finally(() =>{
      setLoading(false)
    })
    if(res.status || res.success) {
      setData(res.data)
      setTotal(res.total || res.data.length)
    }
  }, [form, load])

  const handleReset = useCallback(() => {
    form.resetFields()
  }, [form])

  const handleSearch = useCallback(() => {
    loadCore()
  }, [loadCore])

  useEffect(() => {
    loadCore()
  }, [loadCore])

  return (
    <div>
      {
        searchForm && (
          <div className="mb-10">
            <Form layout="inline" form={form} className={styles['form']}>
              {searchForm}
              <Button type="primary" onClick={handleSearch} disabled={loading}>查询</Button>
              <Button className="ml-10" onClick={handleReset}>重置</Button>
            </Form>
          </div>
        )
      }
      <Table
        size="small"
        dataSource={data}
        columns={ columns }
        rowKey={rowKey}
        loading={loading}
        pagination={
          {
            pageSizeOptions: [10, 50, 100],
            defaultPageSize: 10,
            showSizeChanger: true,
            total,
            position: ['bottomRight'],
            showTotal: (total) => `共${total}条数据`
          }
        }
        scroll={{ y: '350px', x: '500px' }}
        style={{minHeight: '200px'}}
      />
    </div>
  )
}

export default QueryForm
